module.exports = __webpack_public_path__ + "static/media/flag-france.4e2045a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-france.svg
// module id = 1127
// module chunks = 1